<template>
  <v-dialog v-model="showDialog" max-width="800px" @click:outside="close">
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            depressed
            :attrs="attrs"
            v-if="abbreviatedLatestMessage"
            v-on="{ ...tooltip, ...dialog }"
            class="ma-6"
          >
            {{ abbreviatedLatestMessage }}
          </v-btn>

          <v-btn
            depressed
            :attrs="attrs"
            v-else
            v-on="{ ...tooltip, ...dialog }"
            class="ma-6"
          >
            Criar Nota
          </v-btn>
        </template>
        <span v-show="latestMessage">{{ latestMessage }}</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title>
        Notas do Atendimento
        <v-spacer />
        <v-icon @click="close"> eva-close-outline </v-icon>
      </v-card-title>

      <v-divider />

      <v-card-text>
        <v-row>
          <v-col>
            <AttendanceNotes
              :notes="notes"
              :attendanceId="attendanceId"
              :textColor="textColor"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AttendanceNotes from "@/components/attendance/notes.vue";

export default {
  name: "PatientNotes",
  components: {
    AttendanceNotes,
  },
  props: {
    attendanceId: String,
    notes: Array,
  },
  data() {
    return {
      showDialog: false,
      message: "",
      textColor: false,
      subscriptionLoaded: false,
    };
  },
  computed: {
    latestNote() {
      return this.lodash.orderBy(this.notes, ["updatedAt"], ["desc"])[0];
    },
    abbreviatedLatestMessage() {
      return this.latestNote?.message.substring(0, 37);
    },
    latestMessage() {
      return this.latestNote?.message;
    },
  },
  methods: {
    close() {
      this.message = "";
      this.showDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
